import React, { memo } from 'react'

import {
  AsyncSelect,
  FormOnChange,
  MyOptionType,
  SelectProps,
  Stack,
  Text,
} from '@procsea/design-system'

import { RequestableProduct } from 'src/types'

import useAsyncRequestableProductOptions from './useAsyncRequestableProductOptions'

const formatSellerProductOption = ({
  label,
  latinName,
}: MyOptionType<Id> & { latinName: string }) => (
  <Stack>
    <Text>{label}</Text>
    <Text variant="neutral" size="small" italic>
      {latinName}
    </Text>
  </Stack>
)

interface AsyncRequestableProductSelectorProps {
  'data-e2e'?: string
  errorMessage?: string
  fluid?: boolean
  label?: string
  name?: string
  onChange?: FormOnChange<MyOptionType<RequestableProduct> | null>
  required?: SelectProps<MyOptionType<RequestableProduct>, false>['required']
  value?: MyOptionType<RequestableProduct> | null
}

const AsyncRequestableProductSelector = ({
  'data-e2e': dataE2e = 'async-requestable-product-select',
  errorMessage,
  fluid = false,
  label,
  name,
  onChange,
  required,
  value,
}: AsyncRequestableProductSelectorProps) => {
  const { searchForQuery } = useAsyncRequestableProductOptions()

  return (
    <AsyncSelect<MyOptionType<RequestableProduct>, false>
      clearable
      data-e2e={dataE2e}
      defaultOptions={[]}
      errorMessage={errorMessage}
      fluid={fluid}
      formatOptionLabel={formatSellerProductOption as any}
      formatValueLabel={formatSellerProductOption as any}
      label={label}
      loadOptions={searchForQuery}
      name={name}
      noOptionsMessage={() => gettext('Start typing to search for products')}
      onChange={onChange}
      placeholder={gettext('Select a product')}
      required={required}
      value={value as any}
    />
  )
}

export default memo(AsyncRequestableProductSelector)
